import GridDetailRow from './GridDetailRow'

export default GridDetailRow
